import { Component, OnInit } from '@angular/core';
import { CountService } from '../../services/count.service';
import { MailingService } from '../../services/mailing.service';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';


@Component({
    standalone: true,
    imports:[
        RouterModule,
        CommonModule
    ],providers:[
        CountService,
        MailingService
    ],
    selector: 'home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.css']
})

export class HomeComponent implements OnInit {
    count: any = {};
    email: string = '';
    error: string = '';
    isError: boolean = false;

    constructor(private countService: CountService,
                    private mailingService: MailingService) { }

    ngOnInit(): void {
        this.countService.getCount().subscribe(c => {
            this.count = c;
            console.log(c,'count')
        });
    }

    emailSubscribe() {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        var result = re.test(String(this.email).toLowerCase()); 

        if (result) {
            this.error = '';
            this.isError = false;

            this.mailingService.getMailing(this.email).subscribe(m => {
                if (m.length) {
                    this.isError = true
                    this.error = 'Email already subscribed!';
                }
                else{
                    this.mailingService.createMailing(this.email).subscribe(m => {
                        this.error = 'Thanks for subscribing!';
                    });
                }
            });
        }
        else {
            this.isError = true
            this.error = 'Not valid email address!';
        }
    }
}